import Loader from "./Loader";
import { EventEmitter } from "events";
import store from "../store/index"
import * as types from "../store/modules/loader/types"

class Preloader1 extends EventEmitter {
  constructor() {
    super();
    this.loader = new Loader();

    this.loader.on("complete", () => {
      console.log("preloader event complete");
      this.emitComplete();
    });
  }
  start(){
    this.loader.load([
      "/img/ui/kinsi.png",
      "/img/ui/text/move.png",
      "/img/ui/text/rot.png",
      "/img/ui/text/scale.png",
      "/img/ui/tool/can.png",
      "/img/ui/tool/marker.png",
      "/img/ui/tool/key.png",
      "/img/ui/tool/size.png",
      "/img/ui/tutorial/zoom.png",
      "/img/transition2.png",
    ]);
  }

  emitComplete() {
    this.emit("complete");
    store.dispatch(types.namespace + types.SET_LOADED, true);
  }

  getImg(imgName){
    if (this.stock && this.stock[imgName])
      return this.stock[imgName];
    return this.loader.getImg(imgName);
  }

  async loadBgImg(src, anonymous = false) {
    console.log("[Loader] src", src);
    if (!this.stock)
      this.stock = {};
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        img.onload = null;
        img.onerror = null;
        // console.log("image load success", src);
        this.stock[src] = img;
        resolve(img)
      };
      img.onerror = (e) => {
        img.onload = null;
        img.onerror = null;
        console.log("image load error", src, e);
        reject(e);
      };
      if (anonymous)
        img.crossOrigin = "anonymous";
      img.src = src;
    })
  }

  async loadBlobImg(src) {
    console.log("[Loader] loadBlobImg src", src);
    if (!this.stock)
      this.stock = {};

    try {
      // fetch → blob → createObjectURL（iOS 18対策: CORS問題回避）
      const response = await fetch(src, { mode: 'cors' });
      const blob = await response.blob();
      const objectURL = URL.createObjectURL(blob);

      const img = new Image();
      await new Promise((resolve, reject) => {
        img.onload = () => {
          img.onload = null;
          img.onerror = null;
          resolve();
        };
        img.onerror = (e) => {
          img.onload = null;
          img.onerror = null;
          reject(e);
        };
        img.src = objectURL;
      });

      // iOS 18対策: decode完了を保証
      if (img.decode) {
        await img.decode();
      }

      // 元のURLをキーとして保存
      this.stock[src] = img;
      console.log("[Loader] loadBlobImg success", src, img.naturalWidth, img.naturalHeight);
      return img;
    } catch (e) {
      console.log("[Loader] loadBlobImg error", src, e);
      throw e;
    }
  }
}

export const Preloader = new Preloader1();
